export const environment = {
  production: false,
  apiUrl: 'https://homolog.api.simcarecupons.clinicasim.com/api/v1',
};
